/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Dl_File_Linux_Tar_TitleInputs */

const en_pc_dl_file_linux_tar_title = /** @type {(inputs: Pc_Dl_File_Linux_Tar_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tarball (x86_64)`)
};

const zh_pc_dl_file_linux_tar_title = /** @type {(inputs: Pc_Dl_File_Linux_Tar_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`压缩包（x86_64）`)
};

/**
* | output |
* | --- |
* | "Tarball (x86_64)" |
*
* @param {Pc_Dl_File_Linux_Tar_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_dl_file_linux_tar_title = /** @type {((inputs?: Pc_Dl_File_Linux_Tar_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Dl_File_Linux_Tar_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_dl_file_linux_tar_title(inputs)
	return zh_pc_dl_file_linux_tar_title(inputs)
});
export { pc_dl_file_linux_tar_title as "pc.dl.file.linux_tar.title" }